module.exports = __webpack_public_path__ + "static/img/error-page.04bbed1.gif";